enum AccentColor {
  PURPLE = "#613DE5",
  PINK = "#E43DC9",
  GREEN = "#1DA854",
  ORANGE = "#F7700B",
  BLUE = "#1990E8",
}

export default AccentColor;
